export const TICKET_EXPERIENCE_SESSION_KEY = 'ticket_experience';

export const TICKET_UTM_MEDIUM = 'ticket';
